<template>
  <div>
    <div class="ti d-flex">
      <div class="d-flex-left">
        <erp-tree @node-click="nodeClick"></erp-tree>
      </div>
      <div class="d-flex-right" style="margin-top: 10px;">
        <el-button @click="order_update" v-if="ERP.isPermission(4003007002)">订单销账</el-button>
        <el-button @click="change(1)">查询</el-button>
        <div style="width: 99%;">
          <div>
            <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
              <el-descriptions-item label="查询房产/客户">
                <el-autocomplete
                  v-model="house_name"
                  size="mini"
                  style="width: 100%;"
                  :fetch-suggestions="querySearchAsync"
                  placeholder="可搜索房产/客户姓名"
                  clearable
                  @select="handleSelect"
                ></el-autocomplete>
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
            <el-descriptions-item  label="客户名称">
              <div style="display: flex;">
                <div style="width: 70%;">
                  <el-select v-model="select.name"  @change="name_changes" size="mini" clearable placeholder="客户名称" style="width: 90%;">
                    <el-option v-for="item in customer" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                  <span v-if="house_customer > 0" style="color: red;margin-left: 3px;width: 150px;">{{house_customer}}户</span>
                </div>
                <div style="width: 30%;" v-if="house_customer > 0">
                  <div @click="all" style="color: red;text-align: right;margin-top: 5px;cursor: pointer;margin-left: 1px;">查询全部房产费用</div>
                </div>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="房产信息">
              <el-select v-model="select.house" @change="house_changes" size="mini" placeholder="房产信息" style="width: 85%;">
                <el-option v-for="item in house" :key="item.id" :label="item.house" :value="item.house"></el-option>
              </el-select>
              <span v-if="house.length>0" style="color: red;margin-left: 3px;">{{house.length}}条房产</span>
            </el-descriptions-item>
            <el-descriptions-item  label="挂账日期">
              <div v-if="ERP.isPermission(4003007011)">
                <el-date-picker v-model="select.date" type="datetime" size="mini" style="width: 100%;" placeholder="挂账日期"></el-date-picker>
              </div>
              <div v-else>
                <el-date-picker v-model="select.date" type="datetime" size="mini" style="width: 100%;" placeholder="挂账日期" :disabled="disableds"></el-date-picker>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="备注">
              <el-input size="mini" v-model="remerks" placeholder="备注"></el-input>
            </el-descriptions-item>
            <el-descriptions-item  label="结算方式">
              <RadioGroup v-model="select.pay">
                <div style="display: flex;flex-wrap: wrap;">
                  <div v-for="it in dataPay" :key="it.id">
                    <Radio :label="it.number">{{it.name}}</Radio>
                  </div>
                </div>
              </RadioGroup>
            </el-descriptions-item>
            <el-descriptions-item label="汇总方式">
              <Space direction="vertical" size="large">
                <RadioGroup v-model="select.house_type" @on-change="house_type">
                  <Radio label="明细"></Radio>
                  <!-- <Radio label="客户名称"></Radio> -->
                  <!-- <Radio label="房产"></Radio> -->
                  <Radio label="收费周期"></Radio>
                  <!-- <Radio label="房产与收费周期"></Radio> -->
                </RadioGroup>
              </Space>
            </el-descriptions-item>
            <el-descriptions-item  label="计费周期">
              <el-date-picker v-model="select.startDate" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
              <span style="margin-left: 1px;margin-right: 1px;">至</span>
              <el-date-picker v-model="select.endDate" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item  label="收费项目">
              <div>
                <el-select v-model="select.chargeitemID" multiple filterable collapse-tags style="width: 70%" placeholder="收费项目">
                  <el-option size="mini" v-for="item in chargeitem" :key="item.id" :label="item.chargeItem_name" :value="item.id"></el-option>
                </el-select>
                <span style="cursor: pointer" @click="complete">全选</span>
                <span style="margin-left: 3px; cursor: pointer" @click="cancel">取消</span>
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div style="margin-top: 10px;">
          <span>选中金额：<span style="color: red;">{{money_val}}</span>元</span>
          <span style="margin-left: 15px;">总应收金费：<span style="color: red;">{{money}}</span>元</span>
          <span style="margin-left: 15px;color: red;" v-if="loading_dade==2">加载中...</span>
          <el-table ref="multipleTable" height="50vh" :data="tableData" border style="width: 99%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" > </el-table-column>
            <!-- show-overflow-tooltip -->
            <el-table-column v-if="ERP.isPermission(4003007005)" prop="h_name_date" label="房产" width="300"></el-table-column>
            <el-table-column v-else prop="h_name_date" label="房产" show-overflow-tooltip></el-table-column>
            <el-table-column  label="状态" width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.IsFrozen === 1" style="color: red;" @click="getOrderFlow(scope.row.id)">
                  订单冻结
                </div>
                <div v-else-if="scope.row.IsFrozen === 0 && scope.row.froze_money > 0" style="color:red">减免申请中</div>
                <div v-else>正常</div>
              </template>
            </el-table-column>
            <el-table-column prop="chargeItem_name" label="收费项目" width="150"></el-table-column>
            <el-table-column prop="xsc_Price" label="单价" width="80"></el-table-column>
            <el-table-column prop="xsc_Amount" label="用量/面积合计" width="100"></el-table-column>
            <el-table-column prop="charging" label="面积" width="80"></el-table-column>
            <el-table-column  label="计费周期" width="180">
              <template slot-scope="scope">
                {{scope.row.startDate}}-{{scope.row.endDate}}
              </template>
            </el-table-column>
            <el-table-column prop="endDate" label="应收日期" width="100"></el-table-column>
            <el-table-column prop="chargePay" label="本期应收" width="80"></el-table-column>
            <el-table-column prop="charge_sum" label="本期应收欠费" width="109"></el-table-column>
            <el-table-column prop="delaySum" label="违约金欠费" width="100"></el-table-column>
            <el-table-column label="冻结中金额" width="100" prop="froze_money"></el-table-column>
            <el-table-column label="违约金减免" width="100" prop="delayDiscount"></el-table-column>
            <el-table-column label="实收金额" width="100" prop="charge_money"></el-table-column>
          </el-table>
        </div>
        <!-- 打印 -->
        <prints ref="ref"></prints>
        <!-- 票据查询 -->
        <InvoicingSelect ref="invo_select"></InvoicingSelect>
        <NewInvoicingSelect ref="NewInvoicingSelect"></NewInvoicingSelect>
        <FinanceBillDetailed ref="FinanceBillDetailed" />
      </div>
    </div>
  </div>
</template>

<script>
import ViewFlow from "./../Common/ViewFlow";
import FinanceBillDetailed from "./order/FinanceBillDetailed";
import NewInvoicingSelect from "./order/NewInvoicingSelect";


export default {
  name: 'OrderList3',
  provide(){
    return{
      __ORDER__:null
    }
  },
  data () {
    return {
      invoice:{
        'title':'',
        'orderDetailIds': [],
        'phone': "",
        'pid': ""
      },
      pageData:{
        id:0,
        pid:0,
        list:[],
        total:0,
        page:1,
        pageSize:10,
      },
      dialogVisible9:false,
      dialogVisible8:false,
      dialogVisibles:false,
      dialogVisible6:false,
      dialogVisible7:false,
      disableds:true,
      house_name:'',
      loading:false,
      selectList:[],
      select:{
        money:'单价不一致合并',
        house_type:'收费周期',
        pay:'1',
        house:'',
        name:'',
        date:'',
        startDate:'',
        endDate:'',
        chargeitemID:[],
        all:{
          type:1,
          house:'',
        }
      },
      pid:'',
      pid_house:"",
      remerks:'',
      dataPay:[],
      tableData: [],
      customer:[],
      house_customer:0,
      order: [],
      house:[],
      discount_type:[],
      user_type:1,
      money:0,
      money_val:0,
      chargeitem:[],
      loading_dade:1,
      user_room:1,
      discount_data:{
        'id':'',
        'discount_type':'',
        'charge_money':'',
        'data':{}
      },
      prinone:{},
    }
  },
  //界面没出来前加载
  created() {
    var login = window.localStorage.getItem('login');
    if(login == "admin"){
      this.disableds = false;
    }
    //加载收款方式
    this.$myhttp.get('admin/OrderPayment/index',{
      'Content-Type': 'application/json'
    }).then(backdata=>{
      let dataPay = backdata.data.data;
      this.dataPay = dataPay;
      this.select.date = backdata.data.date;
      this.select.pay = dataPay[0]['number']
    });
    //减免类型
    this.$myhttp.get('admin/common/discount_type',{
      'Content-Type': 'application/json'
    }).then(backdata=>{
      this.discount_type = backdata.data.data;
    });
    //加载收费大类（费项）
    this.$myhttp.get("admin/common/getChargeitem", {
      "Content-Type": "application/json",
    }).then((backdata) => {
      this.chargeitem = backdata.data.data;
    });
  },
  // 加载数据
  mounted(){
    this.__ORDER__=this;
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    handleClose(done) {
      done();
    },
    //减免违约金操作
    delayDiscount(data,indexs){
      if(data.delayDiscount == ''){
        return false;
      }
      if(data.delayDiscount == 0){
        return false;
      }
      //console.log(data);
      this.$confirm('确定要减免违约金吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        this.$myhttp.post('admin/OrderList/delayDiscount',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          ERP.hideLoading()
          this.tableData[indexs].delayDiscount = 0;
          if(backdata.data.code == 201){
            this.$Message.error(backdata.data.message);
          }else{
            this.dialogVisibles = false;
            this.$Message.success(backdata.data.message);
            this.change(1);
          }
        },err=>{
          this.tableData[indexs].delayDiscount = 0;
          this.dialogVisibles = false;
          ERP.hideLoading()
          this.$Message.error('请求超时!');
        });
      })
    },
    //全选
    complete() {
      let data = this.chargeitem;
      let id = data
        .map((ret) => {
          return ret.id;
        })
        .join(",");
      let idarray = "[" + id + "]";
      this.select.chargeitemID = JSON.parse(idarray);
    },
    //取消
    cancel() {
      this.select.chargeitemID = [];
    },
    //费用收付
    order_update(){
      this.$confirm('确定核销吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.user_type = 2;
        ERP.showLoading()
        let data = {
          'order':this.order,
          'remerks':this.remerks,
          'pay':this.select.pay,
          'date':this.select.date,
          'house_type':this.select.house_type,
          'customer_id':this.select.name,
          'order_type':'order_amount',
        }
        this.$myhttp.post('admin/OrderList/money_pay',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          ERP.hideLoading()
          if(backdata.data.code == 201){
            this.$confirm(''+backdata.data.message, '提示', {
              confirmButtonText: '关闭',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => { })
            // this.$Message.error(backdata.data.message);
          }else{
            this.$Message.success(backdata.data.message);
            this.dialogVisible6 = true;
            this.prinone = {'id':backdata.data.detail_id,'money':this.select.money,'pid':this.pid};
            // this.prin(backdata.data.detail_id,this.select.money,this.pid);
            this.change(1);
            this.remerks = '';
          }
        },err=>{
          ERP.hideLoading()
          this.$Message.error('请求超时!');
        });
      })
    },

    //点击树
    nodeClick(data){
      this.select.all.type = 1;
      this.select.name = '';
      this.user_type = 1;
      this.user_room = 1;
      this.pid = data.tree[0].pindex_id;
      this.pid_house = data.tree[0].name;
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      if(data.tree[data.tree.length-1].type==='room'){
        this.remerks = '';
        this.select.house=tree_str;
        this.change(1);
        this.user_room = 2;
      }
    },
    //搜索账单
    change(e){
      this.order = [];//清空选中的账单
      //ERP.showLoading()
      this.house_customer = 0;
      this.loading_dade = 2;
      this.house = [];
      this.select.customer = this.customer;
      this.select.pid = this.pid;
      this.$myhttp.post('admin/OrderList/amountOrderList',this.select,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        //ERP.hideLoading()
        if(backdata.data.code == 201){
          this.$Message.error(backdata.data.message);
          return false;
        }
        this.loading_dade = 1;
        let data = backdata.data.data;
        this.tableData = data.data;
        this.money = data.money;
        if(this.user_type == 1){
          this.customer = data.customer;
          this.select.name = data.customer[0].id;
        }
        this.select.date = data.date;
        this.house = data.house;
        if(this.customer.length > 0){
          this.house_customer = this.customer.length - 1;
        }
        this.pid=data.pid;
        this.$forceUpdate();
      },err=>{
        this.loading_dade = 1;
        //ERP.hideLoading()
        this.$Message.error('请求异常!');
      });
    },
    //查询该客户所有费项
    all(){
      this.select.all.type = 2;
      this.select.all.house = this.house.map(req=>{return req.id}).join(',');
      this.change(1);
    },

    //搜索框选中房产
    changes(e){
      this.select.name = '';
      this.user_type = 1;
      this.select.house = e;
      this.change(1);
    },
    //选择客户
    name_changes(e){
      this.user_type = 2
      this.change(1);
    },
    //选择房产
    house_changes(e){
      this.select.all.type = 1;
      this.user_type = 2;
      this.change(1);
    },
    //勾选账单
    handleSelectionChange(val) {
      this.order = val;
      let money = 0;
      this.order.map(req=>{
        money = Number(money) + Number(req.charge_money);
      })
      this.money_val = money.toFixed(2);
    },
    //修改实收金额
    inputs(id,indexs){
      let _this = this;
      let money = 0;
      _this.order.map((req,index)=>{
        if(req.id != id){
          money =  Number(money) + Number(req.charge_money);
        }
        if(req.id == id){
          _this.order[index].charge_money = Number(_this.tableData[indexs].charge_money);
          money =  Number(money) + Number(_this.tableData[indexs].charge_money);
        }
      })
      this.money_val = money.toFixed(2);
    },
    //远程搜索方式
    querySearchAsync(query, cb) {
      if (query !== '') {
        this.loading_dade = 2;
        this.$myhttp.get('admin/common/house_name?house_name='+query,{
          'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.loading_dade = 1;
          this.selectList = backdata.data.data;
          let value = [];
          this.selectList.map(req=>{
            value.push({'value':req.house})
          })
          cb(value)
        });
      }
    },
    //搜索选中
    handleSelect(item) {
      this.select.all.type = 1;
      this.select.name = '';
      this.user_type = 1;
      this.select.house = item.value;
      this.change(1);
      this.user_room = 2;
    },
    pageChange(e) {
      console.log('pageChange', e)
      this.pageData.page = e;
      this.getOrderFlow();
    },
    //点击汇总方式改变
    house_type(v){
      if(this.select.house){
        this.change(1);
      }
    },
    // 订单挂载开票
    order_invoice_mount(){
      if(this.order.length === 0){
        this.$Message.error('请选择开票订单');
        return ;
      }
      this.$refs.invoiceFormRef.openInvoiceForm(this.pid , this.order);
    },
  },
  watch:{

  },
  components: {
    ViewFlow,
    NewInvoicingSelect,
    FinanceBillDetailed,
    "erp-tree": () => import('../Common/erp-tree.vue'),
    "prints": () => import('./order/prints.vue'),
    "Invoicing": () => import('./order/Invoicing.vue'),
    "InvoicingSelect": () => import('./order/InvoicingSelect.vue'),
    "paids": () => import('./order/paids.vue'),
    "frozen": () => import('./order/frozen.vue'),
    "ElectronicInvoice": () => import('./order/electronicInvoice.vue'),
    "orderAdd": () => import('./order/orderAdd.vue'),
    "invoiceForm" : () => import('./order/electronicInvoiceForm.vue'),
  },

}
</script>

<style>
.d-flex {
  display: flex;
}
.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
  width: 250px;

}
.d-flex-right {
  flex: 1;
  overflow-x:hidden;
}
.text2{
  color: rgb(250, 248, 248);
}
</style>

<style lang="scss" scoped>
.right-main {
  display: flex;
  // overflow: auto;//体内容的滚动条
  flex: 1;
  background: #fff;
}
.content{
  .header{

  }
  .header-where{
    margin-top: 5px;
  }
  .body{
    margin-top: 10px;

    .pagination-wrap{
      display: table;
      /* text-align: center; */
      margin: 20px auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/disAmountOrder.vue